import { IconButton, Menu } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import { useState, MouseEvent } from "react";
import type { ComponentType } from "react";
import { TableAction, TableActionProps } from "./TableAction";

export interface TableActionOption<Row> extends TableActionProps<Row> {
  hidden?: boolean;
  visible?: boolean;
  CustomComponent?: ComponentType<
    TableActionOption<Row> & { handleClose: () => void }
  >;
}

interface TableActionsProps<Row> {
  options: TableActionOption<Row>[];
  buttonAlignment?: "vertical" | "horizontal";
}

const TableActions = <Row,>({
  options,
  buttonAlignment = "horizontal",
}: TableActionsProps<Row>) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getOption = (option: TableActionOption<Row>) => {
    if (option.visible === false) {
      return null;
    }
    if (!option.hidden) {
      if (option?.CustomComponent) {
        const { CustomComponent } = option;
        return (
          <CustomComponent
            key={option.label}
            handleClose={handleClose}
            {...option}
          />
        );
      }
      return (
        <TableAction key={option.label} handleClose={handleClose} {...option} />
      );
    }
    return null;
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        {buttonAlignment === "horizontal" && <MoreHorizIcon />}
        {buttonAlignment === "vertical" && <MoreVertIcon />}
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {options.map((option) => getOption(option))}
      </Menu>
    </>
  );
};

export { TableActions };
